
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { ViewContainer } from "../../components/view-container";
import { TicketTableContextProvider } from '@hooks/use-table-context/ticket';
import { TicketTableComponent } from "./ticket-table-component"
import { AddTicketModal } from "./add-ticket-modal";
import { useGetTickets } from "@hooks/use-get/tickets";
import { WpGenericPost, WpTicketMetaBox } from "@hooks/use-get/tickets/types";
import { TicketTableColumnFromApi } from "@hooks/use-config-context/ticket/types";
import { useTicketConfigContext } from "@hooks/use-config-context/ticket";
import { fullBleedViewSx } from "@utils/colors";


export const TicketTable = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editData, setEditData] = useState<any>(null);

    const navigate = useNavigate();
    const { ticketNumber } = useParams();
    const { getOneTicketByTicketNumber } = useGetTickets();
    const { tableColumns } = useTicketConfigContext();

    const handleOpenModal = (data?: any) => {
        setEditData(data && data.id ? data : null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setEditData(null);
        setIsModalOpen(false);

        if (ticketNumber) {
            navigate("/tickets", { replace: true });
        }
    };

    useEffect(() => {
        if (!ticketNumber) return;
        let isCancelled = false;

        const normalizeTicketForEdit = (
            ticket: WpGenericPost<WpTicketMetaBox>,
            ticketColumns: TicketTableColumnFromApi[],
        ) => {
            const flattenedFields = ticketColumns.reduce<Record<string, any>>(
                (acc, column) => {
                    acc[column.id] = column.getValue(ticket);
                    return acc;
                }, {},
            );

            return {
                ...flattenedFields,
                id: ticket.id,
            }
        };

        const loadTicket = async () => {
            const ticket = await getOneTicketByTicketNumber(String(ticketNumber));

            if (!ticket || isCancelled) {
                return;
            }

            handleOpenModal(
                normalizeTicketForEdit(ticket, tableColumns)
            );
        };

        loadTicket();

        return () => {
            isCancelled = true;
        };
    }, [ticketNumber, getOneTicketByTicketNumber, tableColumns]);

    return (
        <TicketTableContextProvider instanceId="page">
            <ViewContainer className="ticket-table-view" sx={fullBleedViewSx}>
                <TicketTableComponent openTicketModal={handleOpenModal}></TicketTableComponent>
                <AddTicketModal
                    key={isModalOpen ? (editData?.id || "new") : "closed"}
                    open={isModalOpen}
                    onClose={handleCloseModal}
                    editData={editData}
                />
            </ViewContainer>
        </TicketTableContextProvider>
    );
};